import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { COLUMN_2 } from 'Components/frameworks/card/Card.constants';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { useAppContext } from 'Context/ReactAppContext';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { UTC_DATE_TIME_FORMAT } from 'Utils/date/apiDate';
import { Card } from 'Components/frameworks/card/Card';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { Spinner } from 'Components/frameworks/spinner/Spinner';
import { Tabs } from 'Components/frameworks/tabs/Tabs';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { getPlanningActivities, getTabsItems } from './qrcodeProductProgramLine.utils';
const NUMBER_OF_DISPLAYED_DAYS = 7;
type Props = {
  noProgramText: string;
  noProgramTitle: string;
  programMissingText: string;
  programMissingTitle: string;
  resortId: string;
  title: string;
};
export const QrcodeProductProgramLine = ({
  noProgramText,
  noProgramTitle,
  programMissingText,
  programMissingTitle,
  resortId,
  title,
}: Props) => {
  const appContext = useAppContext();
  const [activitiesPlanning, setActivitiesPlanning] = useState([]);
  const [isActivitiesPlanningLoading, setIsActivitiesPlanningLoading] = useState(false);
  // Implementation carried on the component side to correct the problem of the timezone of the resort
  useEffect(() => {
    const fetchResortPlanningActivities = async () => {
      setIsActivitiesPlanningLoading(true);
      const {
        resort: { planning },
      } = await getPlanningActivities(resortId, appContext);
      setActivitiesPlanning(planning);
      setIsActivitiesPlanningLoading(false);
    };

    fetchResortPlanningActivities();
  }, []);
  const trackingData = {
    categoryGA: 'landingPage',
    actionGA: 'CTA_ProgrammeDressCodeDate',
  };
  const track = useTracking(trackingData);
  const language = appContext.locale.slice(0, 2);
  const displayedDays = [];
  const associatedActivities = [];

  if (activitiesPlanning.length > 0) {
    for (let i = 0; i < NUMBER_OF_DISPLAYED_DAYS; i++) {
      const day = moment().locale(language).add(i, 'days');
      displayedDays.push(day);
      associatedActivities.push(
        activitiesPlanning.filter(
          ({ startDateTime }) =>
            day.dayOfYear() === moment(startDateTime, UTC_DATE_TIME_FORMAT).dayOfYear(),
        ),
      );
    }
  }

  return (
    <SiteContainer className="Line" id="QrcodeProductProgramLine" size="small">
      <LineTitle>{title}</LineTitle>
      {isActivitiesPlanningLoading && (
        <div className="flex items-center justify-center">
          <Spinner size="small" />
        </div>
      )}
      {!isActivitiesPlanningLoading &&
        (displayedDays.length > 0 ? (
          <Tabs
            className="mt-20"
            hasControlsOnTouch
            isContainerWide
            isScrollable
            items={getTabsItems({
              associatedActivities,
              displayedDays,
              language,
              programMissingText,
              programMissingTitle,
            })}
            onTabClick={(_, index) => {
              const dayLabel = index === 0 ? 'Today' : `Day_${index}`;
              track({
                labelGA: `%Tab${dayLabel}%`,
              });
            }}
            theme="underlined"
          />
        ) : (
          <Card
            color={COLORS.SIENNA}
            heading={{
              iconName: ICONS.DURATION,
              title: noProgramTitle,
            }}
            layout={COLUMN_2}
            text={{
              text: noProgramText,
            }}
          />
        ))}
    </SiteContainer>
  );
};
